import React from 'react';
import { Card, Dropdown } from 'react-bootstrap';
import { IcoEditBox, Trash, IcoEllipsis } from '@icons';
import { translate } from 'components/translation/translation';

const IndustrialAccountCard = ({ year, month, amount, notes, onEdit, onDelete, ...rest }) => {
	return (
		<>
			<Card className="card-industrial-account">
				<Card.Header className="d-flex justify-content-between align-items-center">
					<span>
						{month ?? 'Gennaio'} {year ?? '2040'}
					</span>

					<Dropdown align="end">
						<Dropdown.Toggle
							as="button"
							variant="link"
							className="p-0 border-0 bg-transparent"
							id="dropdown-custom-industrial-account"
							style={{ boxShadow: 'none' }}
						>
							<IcoEllipsis style={{ width: 20, height: 20 }} />
						</Dropdown.Toggle>

						<Dropdown.Menu>
							<Dropdown.Item onClick={onEdit} className="dropdown-edit d-flex align-items-center">
								<span><IcoEditBox style={{ width: 20, height: 20 }} /></span>
								<span className="ms-2">{translate('common.edit', 'Modifica')}</span>
							</Dropdown.Item>

							<Dropdown.Divider />

							<Dropdown.Item onClick={onDelete} className="dropdown-delete d-flex align-items-center">
								<span><Trash className="ico-path-fill-red" style={{ width: 20, height: 20 }} /></span>
								<span className="ms-2">{translate('common.delete', 'Elimina')}</span>
							</Dropdown.Item>
						</Dropdown.Menu>
					</Dropdown>
				</Card.Header>
				<Card.Body>
					<Card.Title>{amount ?? '1000'} €</Card.Title>

					<Card.Text>{notes}</Card.Text>
				</Card.Body>
			</Card>
		</>
	);
};

export default IndustrialAccountCard;
